import {Button, Menu, MenuItem} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {AMSEModuleNode} from '../../../interfaces/AMSEModuleNode';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  setViewType?: Function;
  onOpenItem?: Function;
  onOpenHistory?: Function;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  item?: AMSEModuleNode;
}

const AMSEModuleItemEditButton = <T extends ComponentType = typeof Button>({
  component,
  componentProps,
  children,
  onOpenItem,
  onOpenHistory,
  item,
}: Props<T>) => {
  const Component = component ?? Button;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  return (
    <>
      <Component
        {...componentProps}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {children}
      </Component>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onBackdropClick={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            onOpenItem?.(item?.id, 'e-module', 'update');
            setAnchorEl(null);
          }}
        >
          Edit eModule
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenItem?.(item?.id, 'e-module', 'view');
            setAnchorEl(null);
          }}
        >
          Info & Actions
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenHistory?.(item?.id, 'amsEmoduleCalibration');
            setAnchorEl(null);
          }}
        >
          View Calibration History
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenHistory?.(item?.id, 'amsEmoduleInstallationHistory');
            setAnchorEl(null);
          }}
        >
          View Installstion History
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenHistory?.(item?.id, 'amsEmoduleSensorHistory');
            setAnchorEl(null);
          }}
        >
          View Sensor History
        </MenuItem>
      </Menu>
    </>
  );
};

export default AMSEModuleItemEditButton;
